import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import getters from './getters'
import Storage from '@/utils/storage'

Vue.use(Vuex)

const store = new Vuex.Store({
  // 开启严格模式 —— 一切数据 的修改 只能 通过 mutation 进行
  strict: true,
  state: {
    usToken: Storage.get('usToken'),
    myUserInfo: Storage.get('myUserInfo') ? JSON.parse(Storage.get('myUserInfo')) : {},
    activityInfo: Storage.get('activityInfo') ? JSON.parse(Storage.get('activityInfo')) : {},
  },
  mutations: {
    setToken (state, tokenStr) {
      state.usToken = tokenStr
      Storage.set('usToken', tokenStr)
    },
    setUSERINFO(state, userobj) {
      state.myUserInfo = userobj
      Storage.set('myUserInfo', JSON.stringify(userobj))
    },
    setActivityInfo(state, data) {
      state.activityInfo = data
      Storage.set('activityInfo', JSON.stringify(data))
    },
  },
  actions: {},
  modules: {
    user
  },
  getters
})

export default store
